/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difference`)
};

const es_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencia`)
};

const de_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenz`)
};

const nl_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschil`)
};

const fr_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différence`)
};

const it_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenza`)
};

const pt_br2_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença`)
};

const pt_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença`)
};

const ja_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差分`)
};

const zh_dd_mode_difference = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差值`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_mode_difference = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_mode_difference(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_mode_difference", locale)
	if (locale === "en") return en_dd_mode_difference(inputs)
	if (locale === "es") return es_dd_mode_difference(inputs)
	if (locale === "de") return de_dd_mode_difference(inputs)
	if (locale === "nl") return nl_dd_mode_difference(inputs)
	if (locale === "fr") return fr_dd_mode_difference(inputs)
	if (locale === "it") return it_dd_mode_difference(inputs)
	if (locale === "pt-BR") return pt_br2_dd_mode_difference(inputs)
	if (locale === "pt") return pt_dd_mode_difference(inputs)
	if (locale === "ja") return ja_dd_mode_difference(inputs)
	return zh_dd_mode_difference(inputs)
};